import React from 'react';
import { Table } from 'antd';
import { checkValue, formatDate } from 'utils';
import {
  COLUMN_EXTRA_LARGE,
  COLUMN_MEDIUM,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { priceRender, renderWithTooltip } from 'utils/table';
import { SumRange } from 'components/Filters/SumRange';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { CheckboxFilter } from 'components/Filters/CheckboxFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { turnsType } from '../TurnsForm';

export const turnsTypeMap = {
  cash: 'Наличные',
  cashless: 'Безналичные',
  accruals: 'Начисления',
};

function TurnsTable({
  items,
  loading,
  current,
  pageSize,
  totalRows,
  filters = {},
  onRowClick,
  onFilter,
  onChange,
}) {
  const { f_sum, t_sum, type, start_date, end_date } = filters;

  const columns = [
    {
      width: COLUMN_MEDIUM,
      title: 'Номер документа',
      dataIndex: 'doc_id',
      key: 'doc_id',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Тип',
      dataIndex: 'type',
      key: 'type',
      render: (value) => turnsTypeMap[value],
      filterDropdown: () => {
        return (
          <CheckboxFilter
            filter={type}
            filters={turnsType}
            onFilterChange={(type) => onFilter({ type })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={type} />,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Сумма',
      dataIndex: 'sum',
      key: 'sum',
      render: priceRender,
      filterDropdown: () => {
        return (
          <SumRange
            fromValue={f_sum}
            toValue={t_sum}
            getRange={(first, second) =>
              onFilter({ f_sum: first, t_sum: second })
            }
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_sum || t_sum} />,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Период',
      dataIndex: 'period',
      key: 'period',
      render: (value) => formatDate(value),
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[start_date, end_date]}
            onFilterChange={([start, end]) => {
              onFilter({
                start_date: start,
                end_date: end,
              });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={start_date && end_date} />,
    },
    {
      width: COLUMN_EXTRA_LARGE,
      title: 'Клиент',
      dataIndex: 'company_name',
      key: 'company_name',
      render: (name) => renderWithTooltip(name, 60),
    },
  ];

  const renderSummary = (data) => {
    const total = data.reduce((acc, item) => {
      if (item.sum) {
        return acc + item.sum;
      }

      return acc + 0;
    }, 0);

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
        <Table.Summary.Cell>Итого: {priceRender(total)}</Table.Summary.Cell>
        <Table.Summary.Cell>&nbsp;</Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      summary={renderSummary}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { TurnsTable };
